export const filterOption = (input: string, option: any): boolean => {
  const search = input.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const optionLabel: string = option?.label || option.props?.children || '';
  const optionText = optionLabel.toString().toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  return optionText.includes(search);
};
